import { from, of, EMPTY } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { NotificationService } from 'ui-components/services/notification-service';

import { printJobFactory } from './print-job-factory';
import { handleBulkPrintPusherMessage } from './pusher-message-helpers';

/**
 * @typedef {import('./print-job-factory').PrintJob} PrintJob
 */

/**
 * @typedef {import('ui-components/services/notification-service').NotificationConfig} NotificationConfig
 */

/**
 * @param {object} args
 * @param {() => Promise<string[]>} args.apiRequest
 * @param {number} args.documentCount
 * @param {string} args.documentTypeIdentifier
 * @param {NotificationConfig} args.initialNotification
 * @param {NotificationConfig} args.errorNotification
 * @param {string[]} args.ids
 * @param {object} [args.printer]
 * @param {number} [args.pusherTimeoutMs]
 * @param {string | number} [args.templateId]
 * @returns {import('rxjs').Observable<PrintJob>}
 */
export const jobRunner = ({
  apiRequest,
  documentCount,
  documentTypeIdentifier,
  initialNotification,
  errorNotification,
  ids,
  printer,
  pusherTimeoutMs,
  templateId,
}) => {
  const initialNotificationId = NotificationService.showNotification(initialNotification);
  const showFailureNotification = () => {
    NotificationService.showNotification(errorNotification);
  };
  return from(apiRequest()).pipe(
    mergeMap((jobGuids) => {
      return handleBulkPrintPusherMessage({
        jobGuids,
        documentCount,
        initialNotificationId,
        showFailureNotification,
        pusherTimeoutMs,
      });
    }),
    mergeMap(({ downloadUrl }) => {
      return of(
        printJobFactory({
          documentTypeIdentifier,
          downloadUrl,
          ids,
          printer,
          templateId,
        }),
      );
    }),
    catchError(() => {
      NotificationService.removeNotification(initialNotificationId);
      showFailureNotification();
      return EMPTY;
    }),
  );
};
